module.exports = __webpack_public_path__ + "img/cv-template-6.b1c8ff84.png";